import { DisputeRelatedIcon, PayoutsTabIcon, ReceiptInvoiceIcon, RefundTransactionIcon } from 'assets/icons';

export const TypeFilters = [
  {
    key: 'QR',
    value: 'QR Code'
  },
  {
    key: 'Invoice',
    value: 'Invoice Link'
  }
];

export const StatusFilters = [
  {
    key: 'INITIATED',
    value: 'Initiated'
  },
  {
    key: 'SUCCESS',
    value: 'Success'
  },
  {
    key: 'PENDING',
    value: 'Pending'
  },
  {
    key: 'FAILED',
    value: 'Failed'
  },
  {
    key: 'CANCELLED',
    value: 'Cancelled'
  },
  {
    key: 'TIMED_OUT',
    value: 'Timed Out'
  },
  {
    key: 'BLOCKED',
    value: 'Blocked'
  },
  {
    key: 'REFUNDED',
    value: 'Refunded'
  },
  {
    key: 'REFUND_INITIATED',
    value: 'Refund Initiated'
  },
  {
    key: 'DISPUTED',
    value: 'Disputed'
  }
];

export enum ReceiptsExportPopover {
  TAB_VIEW = 'receipts-export-popover-tab',
  WEB_VIEW = 'receipts-export-popover-web'
}

export enum RelatedItemsType {
  INVOICE = 'INVOICE',
  DISPUTE = 'DISPUTE',
  PAYOUT = 'PAYOUT',
  REFUND = 'REFUND',
  RECEIPT = 'RECEIPT'
}

export const RelatedTypes = {
  INVOICE: {
    icon: ReceiptInvoiceIcon,
    text: 'Invoice'
  },
  REFUND: {
    icon: RefundTransactionIcon,
    text: 'Refund'
  },
  RECEIPT: {
    icon: RefundTransactionIcon,
    text: 'Receipt'
  },
  DISPUTE: {
    icon: DisputeRelatedIcon,
    text: 'Dispute'
  },
  PAYOUT: {
    icon: PayoutsTabIcon,
    text: 'Payout',
    iconClass: 'path-stroke-current text-accentText h-5 w-5'
  }
};
